import { Pause } from 'lucide-react';
import { cn } from '@/lib/cn';
import { localizeLabel, resolvePriority, resolveStatus, STATUS_MAP } from '@/lib/constants';
import { useI18n } from '@/lib/i18n';
import { Badge } from './badge';

interface PillProps { value: string | null | undefined; label?: string; className?: string; }

export function StatusPill({ value, label, className, pausesSla = false }: PillProps & { pausesSla?: boolean }) {
  const { t, tOr } = useI18n();
  const resolved = resolveStatus(value, label);
  const known = Boolean(value && STATUS_MAP[value]);
  const status = {
    ...resolved,
    label: known ? localizeLabel('status', value, resolveStatus(value).label, tOr, label) : (label ?? t('status.unknown')),
  };
  return <Badge className={cn('max-w-40 gap-1.5 truncate', status.color, className)} title={status.label}>
    <span className={cn('h-1.5 w-1.5 shrink-0 rounded-full', status.dot)} aria-hidden="true" />
    <span className="truncate">{status.label}</span>
    {pausesSla && <Pause className="h-3 w-3 shrink-0" aria-label={t('ui.slaPaused')} />}
  </Badge>;
}

export function PriorityPill({ value, label, className }: PillProps) {
  const { tOr } = useI18n();
  const resolved = resolvePriority(value, label);
  const priority = { ...resolved, label: localizeLabel('priority', value, resolvePriority(value).label, tOr, label) };
  return <Badge className={cn('gap-1.5', priority.color, className)} title={priority.label}>
    <span className={cn('h-1.5 w-1.5 shrink-0 rounded-full', priority.dot)} aria-hidden="true" />
    {priority.label}
  </Badge>;
}
